/** Helper to get node implementation or throw an error if not implemented. */
const getNodeImplementation = (nodeImplementations, nodeType) => {
    const nodeImplementation = nodeImplementations[nodeType];
    if (!nodeImplementation) {
        throw new Error(`node [${nodeType}] is not implemented`);
    }
    return {
        dependencies: [],
        ...nodeImplementation,
    };
};

export { getNodeImplementation };
